// extracted by mini-css-extract-plugin
export default {"loading_section":"LoadingSection_loading_section__r38Ik","loading_spinner":"LoadingSection_loading_spinner__2bCv1","loading_text":"LoadingSection_loading_text__0Fsta"};